import axios from 'axios'

// Use production URL for live site, localhost for development
const isProduction = window.location.hostname !== 'localhost';
const baseURL = isProduction ? 'https://api.4posevo.online' : 'http://localhost:8001';

const api = axios.create({
    baseURL: `${baseURL}/api`,
    withCredentials: true
})

export default api